import React from 'react';
import { Box, Flex } from 'rebass/styled-components';
import PropTypes from 'prop-types';
import { LoadMore } from 'components/atoms/LoadMore';

export const TableEmpty = ({ showEmptyView, emptyView, isLoadingMore, isInitialized }) => (
  <>
    {showEmptyView && (
      <Box>
        <Box style={{ padding: 0, border: 'none' }}>
          <Flex justifyContent="center" alignItems="center" width="100%" py={3}>
            {emptyView}
          </Flex>
        </Box>
      </Box>
    )}

    {(isLoadingMore || !isInitialized) && (
      <Box style={{ padding: 0, border: 'none' }}>
        <Flex justifyContent="center" alignItems="center" width="100%" py={3}>
          <LoadMore />
        </Flex>
      </Box>
    )}
  </>
);

TableEmpty.propTypes = {
  showEmptyView: PropTypes.bool,
  emptyView: PropTypes.node,
  isLoadingMore: PropTypes.bool,
  isInitialized: PropTypes.bool,
};

TableEmpty.defaultProps = {
  showEmptyView: false,
  emptyView: null,
  isLoadingMore: false,
  isInitialized: false,
};
